<span *ngIf="type !== 'UserGroup'; else groupRow" class="name">
  <capra-avatar
    class="avatar"
    type="user"
    size="small"
    [options]="avatar">
  </capra-avatar>
  <span>{{name}}</span>
</span>
<ng-template #groupRow>
  <a [href]="link" [target]="target" class="name">
    <mode-group-avatar class="avatar"></mode-group-avatar>
    <span>
      <!-- nesting here to keep the tooltip centered on the text -->
      <span
        capraTooltip
        tooltipContent="Open Group settings in new tab"
        tooltipPlacement="bottom"
        tooltipSize="mini"
      >
        {{name}}
        <capra-icon icon="icon-new-tab" class="icon-new-tab"></capra-icon>
      </span>
    </span>

  </a>
</ng-template>
